import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/img-loader/img-loader';
// import { whiteLabel } from 'Lib/white-label/white-label'; Скрываем до появления новой ЧГ корзины
import { Popup } from 'Lib/popup/popup';

// const popup = new Popup('popup', document.querySelector('.author-page__popup'));
const popups = {};

// window.whiteLabel = whiteLabel;

document.querySelectorAll('[data-popup]').forEach((item) => {
    popups[item.getAttribute('data-popup')] = new Popup('popup', item);
});

document.querySelectorAll('[data-open-popup]').forEach((item) => {
    item.addEventListener('click', () => {
        if (item.classList.contains('advent__house-item_click') && !item.classList.contains('advent__house-item_no-click')) {
            item.classList.add('advent__house-item_active');

            setTimeout(() => {
                popups[item.getAttribute('data-open-popup')]?.open();
            }, 700);
        }
    });
});


$(window).on('load', () => {
    $('.advent__load-box').addClass('advent__load-box_loaded');
    $('body').addClass('body__advent');
});

$('.advent__popup-btn_toogle-btn').on('click', function () {
    $(this).closest('.advent__popup-btn_text-toggle-box').find('.advent__popup-text-toogle').slideToggle();
});

svgSpriteLoader('/landing/advent/svg/sprite.svg?v=20180320');